import React, { Component } from 'react';

import ContentWrapper from '../../components/ContentWrapper';
import PageTitle from '../../components/PageTitle';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// import { WithContext as ReactTags } from 'react-tag-input';
import Autosuggest from 'react-autosuggest';
import TagsInput from 'react-tagsinput'
import 'react-tagsinput/react-tagsinput.css';

import { Link, Redirect } from 'react-router-dom';

import Files from 'react-files';

import TimePicker from 'rc-time-picker';
import 'rc-time-picker/assets/index.css';
import moment from 'moment';

import './StoreEditor.css';

import { 
  loadStores,
  loadStore,
  addStore,
  editStore,
} from '../../reducers/stores';

import update from 'immutability-helper';

import axios from 'axios';

class StoreEditor extends Component {

  state = {
    id: null,
    mode: null,
    added: false,
    edited: false,
    permission: 'Allowed',
    store: {
      store_name: '',
      store_contact_number: '',
      store_email_address: '',
      store_website: '',
      store_description: '',
      store_featured: 0,
      store_trading_hours: 'daily',
      store_trading_hours_custom: [],
      store_trading_hours_daily: {opening_time: moment().hour(8).minute(0), closing_time: moment().hour(18).minute(0)},
      owner_name: '',
      owner_email: '',
      owner_contact_number: '',
      eventbrite_id: '',
      store_location: {
        address: '',
        latitude: '',
        longitude: ''
      }
    },
    categories: [],
    categoriesSuggestions: [],
    tags: [],
    tagsSuggestions: [],
    storeImageFile: null,
    storeImageFileSrc: null,
    isEditingStoreImage: false,
    errors: {
      store_name: null,
      categories: null,
    },
    canAdd: false,
    canEdit: false,
  }

  componentDidMount = () => {

    window.scrollTo(0, 0);
    
    if (!isNaN(parseInt(this.props.match.params.id, 10))) {
      this.setState({mode: 'Edit', id: parseInt(this.props.match.params.id, 10)});
    } else {
      this.setState({mode: 'Add'});
    }

  }

  componentDidUpdate = (prevProps, prevState) => {
    if(!this.props.isLoadingCategories && prevProps.isLoadingCategories !== this.props.isLoadingCategories) {
      this.mapCategoriesSuggestions();
    }
    if(!this.props.isLoadingTags && prevProps.isLoadingTags !== this.props.isLoadingTags) {
      this.mapTagsSuggestions();
    }
    if(this.state.mode === 'Add' && prevState.mode !== this.state.mode) {
      this.mapCategoriesSuggestions();
      this.mapTagsSuggestions();
      this.mapDefaultHours();
    }
    if(this.state.mode === 'Edit' && prevState.mode !== this.state.mode) {
      this.mapCategoriesSuggestions();
      this.mapTagsSuggestions();
      this.loadStoreByID();
    }
  }

  loadStoreByID = () => {
    if(this.state.id){
      this.props.loadStore(this.state.id, (resp) => {
        if(resp.data) {
          this.setState({store: resp.data});
          this.mapStoreToFields();
          this.validateFields();
        } else {
          this.setState({permission: 'Disallowed'});
        }
      });
    }
  }

  getStoreByID = () => {
    const store = this.props.stores.find((store) => {
      return store.id === this.state.id;
    });

    if(store) { this.setState({store}); }
  }

  mapStoreToFields = () => {
    this.mapCategories();
    this.mapTags();
    this.mapStoreImage();
    this.mapHours();
  }

  mapCategories = () => {
    
    if(this.state.store.store_category) {
      const categories = this.state.store.store_category.map((store_category) => {
        return {id: String(store_category.category_id), text: store_category.category_name};
      });
      this.setState({categories}, ()=> {
        this.validateFields();
      });
    }

  }

  mapCategoriesSuggestions = () => {
    let categoriesSuggestions = this.props.categories.map((category) => {
      return {id: String(category.category_id), text: category.category_name};
    });
    
    this.setState({categoriesSuggestions});
  }

  generateguid = () => {
    this.s4 = () => {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
    return this.s4() + this.s4() + '-' + this.s4() + '-' + this.s4() + '-' + this.s4() + '-' + this.s4() + this.s4() + this.s4();
  }

  mapTags = () => {
    if(this.state.store.store_tags) {
      const tags = this.state.store.store_tags.map((store_tag) => {
        // return {id: this.generateguid(), text: store_tag.tag_name}
        return store_tag.tag_name;
      });

      this.setState({tags});
    }
  }

  mapTagsSuggestions = () => {
    let tagsSuggestions = this.props.tags.filter((tag) => {
      return tag ? true : false;
    })
    
    tagsSuggestions = tagsSuggestions.map((tag, index) => {
      return tag;
    });

    this.setState({tagsSuggestions});
  }

  mapStoreImage = () => {
    if(this.state.store.store_image){
      axios.get(this.state.store.store_image).then((resp) => {
        const file = new File([resp.data], this.state.store.store_attachments[0].media_name, {type: "image/*"});
        this.setState({storeImageFile: file, storeImageFileSrc: this.state.store.store_image});
      });
    }
  }

  mapDefaultHours = () => {

    let emptyTradingHoursDaily = { opening_time: moment().hour(8).minute(0), closing_time: moment().hour(18).minute(0)};

    let emptyTradingHoursCustom = [];
    emptyTradingHoursCustom = [
      {"day": "monday", "open": true, opening_time: moment().hour(8).minute(0), closing_time: moment().hour(18).minute(0)},
      {"day": "tuesday", "open": true, opening_time: moment().hour(8).minute(0), closing_time: moment().hour(18).minute(0)},
      {"day": "wednesday", "open": true, opening_time: moment().hour(8).minute(0), closing_time: moment().hour(18).minute(0)},
      {"day": "thursday", "open": true, opening_time: moment().hour(8).minute(0), closing_time: moment().hour(18).minute(0)},
      {"day": "friday", "open": true, opening_time: moment().hour(8).minute(0), closing_time: moment().hour(18).minute(0)},
      {"day": "saturday", "open": false, opening_time: moment().hour(8).minute(0), closing_time: moment().hour(18).minute(0)},
      {"day": "sunday", "open": false, opening_time: moment().hour(8).minute(0), closing_time: moment().hour(18).minute(0)}
    ];

    let newStore = Object.assign({}, this.state.store);
    newStore.store_trading_hours_daily = emptyTradingHoursDaily;
    newStore.store_trading_hours_custom = emptyTradingHoursCustom;
    // this.setState(update(this.state, {store: {store_trading_hours_custom: emptyTradingHoursDaily, store_trading_hours_daily: {$set: emptyTradingHoursDaily}}}))
    this.setState({store: newStore});
  }

  mapHours = () => {
    if(this.state.store.store_trading_hours === 'custom') {
      this.setState(update(this.state, {store: {store_trading_hours_daily: { opening_time: {$set: this.state.store.store_trading_hours_daily.opening_time ? this.state.store.store_trading_hours_daily.opening_time : moment().hour(8).minute(0)}, closing_time: {$set: this.state.store.store_trading_hours_daily.closing_time ? this.state.store.store_trading_hours_daily.closing_time : moment().hour(18).minute(0)}}}}))
    } else if (this.state.store.store_trading_hours === 'daily') {
      let emptyTradingHoursCustom = [];
      if(this.state.store.store_trading_hours_custom.length > 0) {
        emptyTradingHoursCustom = [
          {"day": "monday", "open": this.state.store.store_trading_hours_custom[0].open, opening_time: this.state.store.store_trading_hours_custom[0].opening_time, closing_time: this.state.store.store_trading_hours_custom[0].closing_time},
          {"day": "tuesday", "open": this.state.store.store_trading_hours_custom[1].open, opening_time: this.state.store.store_trading_hours_custom[1].opening_time, closing_time: this.state.store.store_trading_hours_custom[1].closing_time},
          {"day": "wednesday", "open": this.state.store.store_trading_hours_custom[2].open, opening_time: this.state.store.store_trading_hours_custom[2].opening_time, closing_time: this.state.store.store_trading_hours_custom[2].closing_time},
          {"day": "thursday", "open":  this.state.store.store_trading_hours_custom[3].open, opening_time: this.state.store.store_trading_hours_custom[3].opening_time, closing_time: this.state.store.store_trading_hours_custom[3].closing_time},
          {"day": "friday", "open":  this.state.store.store_trading_hours_custom[4].open, opening_time: this.state.store.store_trading_hours_custom[4].opening_time, closing_time: this.state.store.store_trading_hours_custom[4].closing_time},
          {"day": "saturday", "open":  this.state.store.store_trading_hours_custom[5].open, opening_time: this.state.store.store_trading_hours_custom[5].opening_time, closing_time: this.state.store.store_trading_hours_custom[5].closing_time},
          {"day": "sunday", "open":  this.state.store.store_trading_hours_custom[6].open, opening_time: this.state.store.store_trading_hours_custom[6].opening_time, closing_time: this.state.store.store_trading_hours_custom[6].closing_time}
        ]
      } else {
        emptyTradingHoursCustom = [
          {"day": "monday", "open": true, opening_time: moment().hour(8).minute(0), closing_time: moment().hour(18).minute(0)},
          {"day": "tuesday", "open": true, opening_time: moment().hour(8).minute(0), closing_time: moment().hour(18).minute(0)},
          {"day": "wednesday", "open": true, opening_time: moment().hour(8).minute(0), closing_time: moment().hour(18).minute(0)},
          {"day": "thursday", "open": true, opening_time: moment().hour(8).minute(0), closing_time: moment().hour(18).minute(0)},
          {"day": "friday", "open": true, opening_time: moment().hour(8).minute(0), closing_time: moment().hour(18).minute(0)},
          {"day": "saturday", "open": false, opening_time: moment().hour(8).minute(0), closing_time: moment().hour(18).minute(0)},
          {"day": "sunday", "open": false, opening_time: moment().hour(8).minute(0), closing_time: moment().hour(18).minute(0)}
        ]
      }
      this.setState(update(this.state, {store: {store_trading_hours_custom: {$set: emptyTradingHoursCustom}}}))
    }
  }


  handleStoreNameChange = (e) => {
    this.setState(update(this.state, {store: {store_name: {$set: e.target.value}}}), () => {

      if(this.state.store.store_name.length === 0) {
        this.setState(update(this.state, {errors: {store_name: {$set: 'Store name must not be empty'}}}));
      } else if( this.state.store.store_name.length > 0) {
        this.setState(update(this.state, {errors: {store_name: {$set: null}}}));
      }

      this.validateFields();
    });
  }

  
  handleChangeCategory = (categories) => {
    this.setState({categories}, () => {

      if(this.state.categories.length === 0) {
        this.setState(update(this.state, {errors: {categories: {$set: 'Please add at least one category'}}}));
      } else if( this.state.categories.length > 0) {
        this.setState(update(this.state, {errors: {categories: {$set: null}}}));
      }

      this.validateFields();
    })
  }

  handleStoreContactNumberChange = (e) => {
    this.setState(update(this.state, {store: {store_contact_number: {$set: e.target.value}}}));
  }

  handleStoreEmailAddressChange = (e) => {
    this.setState(update(this.state, {store: {store_email_address: {$set: e.target.value}}}));
  }

  handleStoreWebsiteChange = (e) => {
    this.setState(update(this.state, {store: {store_website: {$set: e.target.value}}}));
  }

  handleStoreDescriptionChange = (e) => {
    this.setState(update(this.state, {store: {store_description: {$set: e.target.value}}}));
  }

  handleChangeTag = (tags) => {
    this.setState({tags})
  }

  handleStoreImageChange = (file) => {
    if(file.length){
      this.setState({storeImageFile: file[0]}, () => { } );
      const reader  = new FileReader();
  
      reader.onload = (e) => {
        this.setState({storeImageFileSrc: e.target.result, isEditingStoreImage: true});
      };
      reader.readAsDataURL(file[0]);
    }
  }

  handleStoreImageChangeError = (error, file) => {
    window.alert(`${error.message}`);
  }

  removeStoreImage = () => {
    this.setState({storeImageFile: null, storeImageFileSrc: null});
  }

  handleStoreFeatured = () => {
    this.setState(update(this.state, {store: {store_featured: {$set: this.state.store.store_featured ? 0 : 1}}}));
  }

  handleStoreTradingHoursChange = (tradingHours) => {
    this.setState(update(this.state, {store: {store_trading_hours: {$set: tradingHours}}}), () => {
      this.mapHours();
    })
  }

  handleStoreTradingHoursCustomOpen = (index) => {
    this.setState(update(this.state, {store: {store_trading_hours_custom: {[index]: {open: {$set: !this.state.store.store_trading_hours_custom[index].open}}}}}));
  }

  updateTradingHoursDailyOpeningTime = (e, index) => {
    if(e){
      this.setState(update(this.state, {store: {store_trading_hours_daily: {opening_time: {$set: e.format('YYYY-MM-DD HH:mm:ss')}}}}));
    }
  }

  updateTradingHoursDailyClosingTime = (e, index) => {
    if(e){
      this.setState(update(this.state, {store: {store_trading_hours_daily: {closing_time: {$set: e.format('YYYY-MM-DD HH:mm:ss')}}}}));
    }
  }

  updateTradingHoursCustomOpeningTimeDay = (e, index) => {
    if(e){
      this.setState(update(this.state, {store: {store_trading_hours_custom: {[index]: {opening_time: {$set: e.format('YYYY-MM-DD HH:mm:ss')}}}}}));
    }
  }

  updateTradingHoursCustomClosingTimeDay = (e, index) => {
    if(e){
      this.setState(update(this.state, {store: {store_trading_hours_custom: {[index]: {closing_time: {$set: e.format('YYYY-MM-DD HH:mm:ss')}}}}}));
    }
  }

  handleStoreOwnerNameChange = (e) => {
    this.setState(update(this.state, {store: {owner_name: {$set: e.target.value}}}));
  }

  handleStoreOwnerEmailAddressChange = (e) => {
    this.setState(update(this.state, {store: {owner_email: {$set: e.target.value}}}));
  }

  handleStoreOwnerContactNumberChange = (e) => {
    this.setState(update(this.state, {store: {owner_contact_number: {$set: e.target.value}}}));
  }

  handleStoreEventbriteIDChange = (e) => {
    this.setState(update(this.state, {store: {eventbrite_id: {$set: e.target.value}}}));
  }

  handleStoreLocationAddressChange = (e) => {
    this.setState(update(this.state, {store: {store_location: {address: {$set: e.target.value}}}}));
  }

  handleStoreLocationLatitudeChange = (e) => {
    this.setState(update(this.state, {store: {store_location: {latitude: {$set: e.target.value}}}}));
  }

  handleStoreLocationLongitudeChange = (e) => {
    this.setState(update(this.state, {store: {store_location: {longitude: {$set: e.target.value}}}}));
  }

  addStore = () => {
    
    const store = Object.assign({}, this.state.store);
    delete store.id;
    delete store.date_created;
    delete store.category_id;
    delete store.store_attachments;
    delete store.store_image;

    store.address = store.store_location.address;
    store.latitude = parseFloat(store.store_location.latitude);
    store.longitude = parseFloat(store.store_location.longitude);  
    
    store.store_category = this.state.categories.map((store_category) => {
      return parseInt(store_category.id, 10);
    });

    
    store.store_tags = this.state.tags.map((store_tag) => {
      return {
        "tag_name": store_tag
      }
    });

    store.store_trading_hours_daily.opening_time = moment(store.store_trading_hours_daily.opening_time).format('YYYY-MM-DD HH:mm:ss');
    store.store_trading_hours_daily.closing_time = moment(store.store_trading_hours_daily.closing_time).format('YYYY-MM-DD HH:mm:ss');
    store.store_trading_hours_custom = store.store_trading_hours_custom.map((day) => {
      return {
        day: day.day,
        open: day.open,
        opening_time: moment(day.opening_time).format('YYYY-MM-DD HH:mm:ss'),
        closing_time: moment(day.closing_time).format('YYYY-MM-DD HH:mm:ss'),
      };
    });
    

    store.store_featured = String(store.store_featured);
    store.is_active = String(1);

    const data = new FormData()
    data.append('data', JSON.stringify(store));

    if(this.state.isEditingStoreImage){
      data.append('file', this.state.storeImageFile);
    }

    this.props.addStore(data, (resp) => {
      this.setState({added: true});
      this.props.loadStores();
    });
  }

  editStore = () => {
    
    const store = Object.assign({}, this.state.store);
    delete store.id;
    delete store.date_created;
    delete store.category_id;
    delete store.store_attachments;
    delete store.store_image;

    store.address = store.store_location.address;
    store.latitude = parseFloat(store.store_location.latitude);
    store.longitude = parseFloat(store.store_location.longitude); 
    
    store.store_category = this.state.categories.map((store_category) => {
      return parseInt(store_category.id, 10);
    });

    
    store.store_tags = this.state.tags.map((store_tag) => {
      return {
        "tag_name": store_tag
      }
    });

    store.store_trading_hours_daily.opening_time = moment(store.store_trading_hours_daily.opening_time).format('YYYY-MM-DD HH:mm:ss');
    store.store_trading_hours_daily.closing_time = moment(store.store_trading_hours_daily.closing_time).format('YYYY-MM-DD HH:mm:ss');
    store.store_trading_hours_custom = store.store_trading_hours_custom.map((day) => {
      return {
        day: day.day,
        open: day.open,
        opening_time: moment(day.opening_time).format('YYYY-MM-DD HH:mm:ss'),
        closing_time: moment(day.closing_time).format('YYYY-MM-DD HH:mm:ss'),
      };
    });
    

    store.store_featured = String(store.store_featured);
    store.is_active = String(store.is_active);

    const data = new FormData()
    data.append('data', JSON.stringify(store));

    if(this.state.isEditingStoreImage){
      data.append('file', this.state.storeImageFile);
    }

    this.props.editStore(this.state.id, data, (resp) => {
      this.setState({edited: true});
      this.props.loadStores();
    });
  }

  validateFields = () => {
    let flag = true;

    if(this.state.store.store_name.length === 0) {
      flag = false;
    } else if( this.state.store.store_name.length > 0) {
    }

    if(this.state.categories.length === 0) {
      flag = false;
    } else if( this.state.categories.length > 0) {
    }

    if(flag) {
      if(this.state.mode === 'Add') {
        this.setState({canAdd: true});
      } else if (this.state.mode === 'Edit') {
        this.setState({canEdit: true});
      }
    } else {
      if(this.state.mode === 'Add') {
        this.setState({canAdd: false});
      } else if (this.state.mode === 'Edit') {
        this.setState({canEdit: false});
      }
    }

  }

  render() {

    if (this.state.permission !== 'Allowed' || this.state.added || this.state.edited) {
      return <Redirect to='/pointofinterests'/>;
    }

    this.renderCategoryTag = (props) => {
      let {tag, key, disabled, onRemove, classNameRemove, getTagDisplayValue, ...other} = props
      return (
        <span key={key} {...other} className={`btn btn-primary btn-tag`} onClick={(e) => onRemove(key)}>
          {getTagDisplayValue(tag.text)}
        </span>
      )
    }

    this.renderTagsTag = (props) => {
      let {tag, key, disabled, onRemove, classNameRemove, getTagDisplayValue, ...other} = props
      return (
        <span key={key} {...other} className={`btn btn-primary btn-tag`} onClick={(e) => onRemove(key)}>
          {getTagDisplayValue(tag)}
        </span>
      )
    }

    this.autocompleteRenderCategoryInput = ({addTag, ...props}) => {
      const handleOnChange = (e, {newValue, method}) => {
        if (method === 'enter') {
          e.preventDefault()
        } else {
          props.onChange(e)
        }
      }

      const inputValue = (props.value && props.value.trim().toLowerCase()) || ''
      const inputLength = inputValue.length

      let suggestions = this.state.categoriesSuggestions.filter((category) => {
        const categoryIDs = this.state.categories.map((category) => { return category.id; });
        return category.text.toLowerCase().slice(0, inputLength) === inputValue && categoryIDs.indexOf(category.id) === -1;
      })

      return (
        <Autosuggest
          ref={props.ref}
          suggestions={suggestions}
          shouldRenderSuggestions={(value) => value && value.trim().length > 0}
          getSuggestionValue={(suggestion) => suggestion.text}
          renderSuggestion={(suggestion) => <span className="btn btn-light">{suggestion.text}</span>}
          inputProps={{...props, onChange: handleOnChange}}
          onSuggestionSelected={(e, {suggestion}) => {
            addTag(suggestion)
          }}
          onBlur={() => {return false;}}
          onSuggestionsClearRequested={() => {}}
          onSuggestionsFetchRequested={() => {}}
        />
      )
    }

    this.autocompleteRenderTagsInput = ({addTag, ...props}) => {
      const handleOnChange = (e, {newValue, method}) => {
        if (method === 'enter') {
          e.preventDefault()
        } else {
          props.onChange(e)
        }
      }

      const inputValue = (props.value && props.value.trim().toLowerCase()) || ''
      const inputLength = inputValue.length

      let suggestions = this.state.tagsSuggestions.filter((tag) => {
        return tag.toLowerCase().slice(0, inputLength) === inputValue && this.state.tags.indexOf(tag) === -1;
      })

      return (
        <Autosuggest
          ref={props.ref}
          suggestions={suggestions}
          shouldRenderSuggestions={(value) => value && value.trim().length > 0}
          getSuggestionValue={(suggestion) => suggestion}
          renderSuggestion={(suggestion) => <span className="btn btn-light">{suggestion}</span>}
          inputProps={{...props, onChange: handleOnChange}}
          onSuggestionSelected={(e, {suggestion}) => {
            addTag(suggestion)
          }}
          onBlur={() => {return false;}}
          onSuggestionsClearRequested={() => {}}
          onSuggestionsFetchRequested={() => {}}
        />
      )
    }

    return (
      <ContentWrapper>
        <div className="inner-content">
          <PageTitle>{this.state.mode === 'Add' ? 'Add' : ''}{this.state.mode === 'Edit' ? 'Edit' : ''} Point of Interest</PageTitle>

          <div className="container-fluid">
            <div className="row" role="toolbar" aria-label="Toolbar with button groups">
              <div className="col-md-4 offset-md-8 text-right">
                <Link to='/pointofinterests'><button className="btn btn-light" style={{marginRight: '10px'}}>Cancel</button></Link>
                {this.state.mode === 'Add' &&
                  <button className="btn btn-primary" onClick={this.addStore} disabled={this.props.isAddingStore || !this.state.canAdd} >Add Point of Interest</button>
                }
                {this.state.mode === 'Edit' &&
                  <button className="btn btn-primary" onClick={this.editStore} disabled={this.props.isEditingStore || !this.state.canEdit} >Edit Point of Interest</button>
                }
              </div>
            </div>
          </div>

          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <h3>Point of Interest Details</h3>
                <hr />
              </div>
            </div>
            <div className="row">
              <div className="col-md-8 col-sm-12">
                <form>
                  <div className="form-group">
                    <label htmlFor="storeName">Point of Interest Name *</label>
                    <input type="text" className="form-control" id="storeName" value={this.state.store.store_name} onChange={this.handleStoreNameChange} placeholder="Point of Interest Name" autoFocus />
                    {this.state.errors.store_name &&
                      <small id="storeNameError" className="form-text text-muted">{this.state.errors.store_name}</small>
                    }
                  </div>
                  <div className="form-group">
                    <label htmlFor="storeCategory">Point of Interest Categories *</label>
                    <TagsInput renderInput={this.autocompleteRenderCategoryInput} renderTag={this.renderCategoryTag} value={this.state.categories} onChange={this.handleChangeCategory} inputProps={{placeholder: 'Add a Category'}} />
                    {this.state.errors.categories &&
                      <small id="storeNameError" className="form-text text-muted">{this.state.errors.categories}</small>
                    }
                  </div>
                  <div className="form-group">
                    <label htmlFor="storeContactNumber">Point of Interest Contact Number</label>
                    <input type="text" className="form-control" id="storeContactNumber" value={this.state.store.store_contact_number} onChange={this.handleStoreContactNumberChange} placeholder="Point of Interest Contact Number" />
                  </div>
                  <div className="form-group">
                    <label htmlFor="storeEmailAddress">Point of Interest Email Address</label>
                    <input type="email" className="form-control" id="storeEmailAddress" value={this.state.store.store_email_address} onChange={this.handleStoreEmailAddressChange} placeholder="Point of Interest Email Address" />
                  </div>
                  <div className="form-group">
                    <label htmlFor="storeWebsite">Point of Interest Website</label>
                    <input type="email" className="form-control" id="storeWebsite" value={this.state.store.store_website} onChange={this.handleStoreWebsiteChange} placeholder="Point of Interest Website" />
                  </div>
                  <div className="form-group">
                    <label htmlFor="storeDescription">Point of Interest Description</label>
                    <textarea className="form-control" id="storeDescription" rows="3" value={this.state.store.store_description} onChange={this.handleStoreDescriptionChange} ></textarea>
                  </div>
                  <div className="form-group">
                    <label htmlFor="storeTags">Point of Interest Tags</label>
                    <TagsInput renderInput={this.autocompleteRenderTagsInput} renderTag={this.renderTagsTag} value={this.state.tags} onChange={this.handleChangeTag} inputProps={{placeholder: 'Add a Tag'}} />
                  </div>
                  <div className="form-group">
                    <label htmlFor="storeImage">Point of Interest Image</label>
                    {this.state.storeImageFile ? 
                      <div>
                        <div style={{backgroundImage: `url(${this.state.storeImageFileSrc}), url('/trans.png')`, marginRight: '20px', height: '200px', width: '300px', border: 'solid 1px #ced4da', borderRadius: '.25rem', backgroundSize: 'contain, auto', backgroundRepeat: 'no-repeat, repeat', backgroundPosition: 'center', float: 'left'}}></div>
                        <div style={{float: 'left'}}>
                          {this.state.storeImageFile.name} <br/>
                          {this.state.storeImageFile.size} <br/>
                          {this.state.storeImageFile.type} <br/>
                          <a className="btn btn-danger btn-sm" style={{color: 'white', marginTop: '10px'}} onClick={this.removeStoreImage}>Remove</a>
                        </div>
                        <div style={{clear: 'both'}}></div>
                      </div>
                      :
                      <Files name="svg" accepts={['image/*']} clickable className="field-drop inputClass" onError={this.handleStoreImageChangeError} onChange={this.handleStoreImageChange} maxFileSize={10000000}  style={{display: 'block', height: '200px', width: '300px', border: 'solid 1px #ced4da', borderRadius: '.25rem'}} dropActiveClassName="dropping">
                        <div className="centered"><a className="btn btn-primary">Add Image</a></div>
                      </Files>
                    }
                    <small id="storeImageError" className="form-text text-muted">Max file size 1MB.</small>
                  </div>
                  <div className="form-group">
                    <label htmlFor="storeWebsite">Feature Point of Interest</label><br/>
                    <a className={`btn ${this.state.store.store_featured ? `btn-warning` : `btn-light`}`} onClick={this.handleStoreFeatured}><i className="fa fa-star"/></a>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <h3>Opening Hours</h3>
                <hr />
              </div>
            </div>
            <div className="row">
              <div className="col-md-8 col-sm-12">
                <ul className="nav nav-tabs">
                  <li className={`nav-item`}>
                    <a className={`nav-link ${this.state.store.store_trading_hours === 'daily' ? 'active': ''}`} onClick={() => this.handleStoreTradingHoursChange('daily')}>Daily</a>
                  </li>
                  <li className={`nav-item`}>
                    <a className={`nav-link ${this.state.store.store_trading_hours === 'custom' ? 'active': ''}`} onClick={() => this.handleStoreTradingHoursChange('custom')}>Custom</a>
                  </li>
                </ul>
                <div id="storeTradingHours">
                  {this.state.store.store_trading_hours === 'daily' &&
                    <div className="tab-pane">
                      <form>
                        <div className="form-group" style={{margin: '20px 0'}}>
                          <div className="row">
                            <div className="col">
                              <label>Opening Time</label>
                              <TimePicker showSecond={false} defaultValue={moment().hour(8).minute(0)} value={moment(this.state.store.store_trading_hours_daily.opening_time, "YYYY-MM-DD hh:mm:ss")} onChange={(e) => this.updateTradingHoursDailyOpeningTime(e, 0)} className="input" format={`h:mm a`} use12Hours inputReadOnly />
                            </div>
                            <div className="col">
                              <label>Closing Time</label>
                              <TimePicker showSecond={false} defaultValue={moment().hour(17).minute(0)} value={moment(this.state.store.store_trading_hours_daily.closing_time, "YYYY-MM-DD hh:mm:ss")} onChange={(e) => this.updateTradingHoursDailyClosingTime(e, 0)} className="input" format={`h:mm a`} use12Hours inputReadOnly />
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  }
                  {this.state.store.store_trading_hours === 'custom' &&
                    <div className="tab-pane">
                      <form>
                        <div className="form-group" style={{margin: '20px 0'}}>
                          <div className="row">
                            <div className="col col-md-3 text-center">
                              Day
                            </div>
                            <div className="col">
                              <label>Opening Time</label>
                            </div>
                            <div className="col">
                              <label>Closing Time</label>
                            </div>
                          </div>
                          <div className="row store_trading_hours_day">
                            <div className="col col-md-3">
                              <div className="checkbox-input">
                                <a className={`btn btn-sm ${this.state.store.store_trading_hours_custom[0].open ? `btn-primary` : `btn-light`}`} onClick={() => {this.handleStoreTradingHoursCustomOpen(0)}}><i className={`fa ${this.state.store.store_trading_hours_custom[0].open ? `fa-check` : `fa-minus`}`}/></a> Monday
                              </div>
                            </div>
                            <div className="col">
                              <TimePicker showSecond={false} value={moment(this.state.store.store_trading_hours_custom[0].opening_time, "YYYY-MM-DD hh:mm:ss")} onChange={(e) => this.updateTradingHoursCustomOpeningTimeDay(e, 0)} className="input" format={`h:mm a`} use12Hours />
                            </div>
                            <div className="col">
                              <TimePicker showSecond={false} value={moment(this.state.store.store_trading_hours_custom[0].closing_time, "YYYY-MM-DD hh:mm:ss")} onChange={(e) => this.updateTradingHoursCustomClosingTimeDay(e,0)} className="input" format={`h:mm a`} use12Hours inputReadOnly />
                            </div>
                          </div>
                          <div className="row store_trading_hours_day">
                            <div className="col col-md-3">
                              <div className="checkbox-input">
                                <a className={`btn btn-sm ${this.state.store.store_trading_hours_custom[1].open ? `btn-primary` : `btn-light`}`} onClick={() => {this.handleStoreTradingHoursCustomOpen(1)}}><i className={`fa ${this.state.store.store_trading_hours_custom[1].open ? `fa-check` : `fa-minus`}`}/></a> Tuesday
                              </div>
                            </div>
                            <div className="col">
                              <TimePicker showSecond={false} value={moment(this.state.store.store_trading_hours_custom[1].opening_time, "YYYY-MM-DD hh:mm:ss")} onChange={(e) => this.updateTradingHoursCustomOpeningTimeDay(e, 1)}className="input" format={`h:mm a`} use12Hours inputReadOnly />
                            </div>
                            <div className="col">
                              <TimePicker showSecond={false} value={moment(this.state.store.store_trading_hours_custom[1].closing_time, "YYYY-MM-DD hh:mm:ss")} onChange={(e) => this.updateTradingHoursCustomClosingTimeDay(e,1)}className="input" format={`h:mm a`} use12Hours inputReadOnly />
                            </div>
                          </div>
                          <div className="row store_trading_hours_day">
                            <div className="col col-md-3">
                              <div className="checkbox-input">
                                <a className={`btn btn-sm ${this.state.store.store_trading_hours_custom[2].open ? `btn-primary` : `btn-light`}`} onClick={() => {this.handleStoreTradingHoursCustomOpen(2)}}><i className={`fa ${this.state.store.store_trading_hours_custom[2].open ? `fa-check` : `fa-minus`}`}/></a> Wednesday
                              </div>
                            </div>
                            <div className="col">
                              <TimePicker showSecond={false} value={moment(this.state.store.store_trading_hours_custom[2].opening_time, "YYYY-MM-DD hh:mm:ss")} onChange={(e) => this.updateTradingHoursCustomOpeningTimeDay(e, 2)}className="input" format={`h:mm a`} use12Hours inputReadOnly />
                            </div>
                            <div className="col">
                              <TimePicker showSecond={false} value={moment(this.state.store.store_trading_hours_custom[2].closing_time, "YYYY-MM-DD hh:mm:ss")} onChange={(e) => this.updateTradingHoursCustomClosingTimeDay(e,2)}className="input" format={`h:mm a`} use12Hours inputReadOnly />
                            </div>
                          </div>
                          <div className="row store_trading_hours_day">
                            <div className="col col-md-3">
                              <div className="checkbox-input">
                                <a className={`btn btn-sm ${this.state.store.store_trading_hours_custom[3].open ? `btn-primary` : `btn-light`}`} onClick={() => {this.handleStoreTradingHoursCustomOpen(3)}}><i className={`fa ${this.state.store.store_trading_hours_custom[3].open ? `fa-check` : `fa-minus`}`}/></a> Thursday
                              </div>
                            </div>
                            <div className="col">
                              <TimePicker showSecond={false} value={moment(this.state.store.store_trading_hours_custom[3].opening_time, "YYYY-MM-DD hh:mm:ss")} onChange={(e) => this.updateTradingHoursCustomOpeningTimeDay(e, 3)}className="input" format={`h:mm a`} use12Hours inputReadOnly />
                            </div>
                            <div className="col">
                              <TimePicker showSecond={false} value={moment(this.state.store.store_trading_hours_custom[3].closing_time, "YYYY-MM-DD hh:mm:ss")} onChange={(e) => this.updateTradingHoursCustomClosingTimeDay(e,3)}className="input" format={`h:mm a`} use12Hours inputReadOnly />
                            </div>
                          </div>
                          <div className="row store_trading_hours_day">
                            <div className="col col-md-3">
                              <div className="checkbox-input">
                                <a className={`btn btn-sm ${this.state.store.store_trading_hours_custom[4].open ? `btn-primary` : `btn-light`}`} onClick={() => {this.handleStoreTradingHoursCustomOpen(4)}}><i className={`fa ${this.state.store.store_trading_hours_custom[4].open ? `fa-check` : `fa-minus`}`}/></a> Friday
                              </div>
                            </div>
                            <div className="col">
                              <TimePicker showSecond={false} value={moment(this.state.store.store_trading_hours_custom[4].opening_time, "YYYY-MM-DD hh:mm:ss")} onChange={(e) => this.updateTradingHoursCustomOpeningTimeDay(e, 4)}className="input" format={`h:mm a`} use12Hours inputReadOnly />
                            </div>
                            <div className="col">
                              <TimePicker showSecond={false} value={moment(this.state.store.store_trading_hours_custom[4].closing_time, "YYYY-MM-DD hh:mm:ss")} onChange={(e) => this.updateTradingHoursCustomClosingTimeDay(e,4)}className="input" format={`h:mm a`} use12Hours inputReadOnly />
                            </div>
                          </div>
                          <div className="row store_trading_hours_day">
                            <div className="col col-md-3">
                              <div className="checkbox-input">
                                <a className={`btn btn-sm ${this.state.store.store_trading_hours_custom[5].open ? `btn-primary` : `btn-light`}`} onClick={() => {this.handleStoreTradingHoursCustomOpen(5)}}><i className={`fa ${this.state.store.store_trading_hours_custom[5].open ? `fa-check` : `fa-minus`}`}/></a> Saturday
                              </div>
                            </div>
                            <div className="col">
                              <TimePicker showSecond={false} value={moment(this.state.store.store_trading_hours_custom[5].opening_time, "YYYY-MM-DD hh:mm:ss")} onChange={(e) => this.updateTradingHoursCustomOpeningTimeDay(e, 5)}className="input" format={`h:mm a`} use12Hours inputReadOnly />
                            </div>
                            <div className="col">
                              <TimePicker showSecond={false} value={moment(this.state.store.store_trading_hours_custom[5].closing_time, "YYYY-MM-DD hh:mm:ss")} onChange={(e) => this.updateTradingHoursCustomClosingTimeDay(e,5)}className="input" format={`h:mm a`} use12Hours inputReadOnly />
                            </div>
                          </div>
                          <div className="row store_trading_hours_day">
                            <div className="col col-md-3">
                              <div className="checkbox-input">
                                <a className={`btn btn-sm ${this.state.store.store_trading_hours_custom[6].open ? `btn-primary` : `btn-light`}`} onClick={() => {this.handleStoreTradingHoursCustomOpen(6)}}><i className={`fa ${this.state.store.store_trading_hours_custom[6].open ? `fa-check` : `fa-minus`}`}/></a> Sunday
                              </div>
                            </div>
                            <div className="col">
                              <TimePicker showSecond={false} value={moment(this.state.store.store_trading_hours_custom[6].opening_time, "YYYY-MM-DD hh:mm:ss")} onChange={(e) => this.updateTradingHoursCustomOpeningTimeDay(e, 6)}className="input" format={`h:mm a`} use12Hours inputReadOnly />
                            </div>
                            <div className="col">
                              <TimePicker showSecond={false} value={moment(this.state.store.store_trading_hours_custom[6].closing_time, "YYYY-MM-DD hh:mm:ss")} onChange={(e) => this.updateTradingHoursCustomClosingTimeDay(e,6)}className="input" format={`h:mm a`} use12Hours inputReadOnly />
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>

          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <h3>Point of Interest Owner Details</h3>
                <hr />
              </div>
            </div>
            <div className="row">
              <div className="col-md-8 col-sm-12">
                <form>
                  <div className="form-group">
                    <label htmlFor="storeOwnerName">Point of Interest Owner Name</label>
                    <input type="text" className="form-control" id="storeOwnerName" value={this.state.store.owner_name} onChange={this.handleStoreOwnerNameChange} placeholder="Point of Interest Owner Name" />
                  </div>
                  <div className="form-group">
                    <label htmlFor="storeOwnerEmailAddress">Point of Interest Owner Email Address</label>
                    <input type="text" className="form-control" id="storeOwnerEmailAddress" value={this.state.store.owner_email} onChange={this.handleStoreOwnerEmailAddressChange} placeholder="Point of Interest Owner Email Address" />
                  </div>
                  <div className="form-group">
                    <label htmlFor="storeOwnerContactNumber">Point of Interest Owner Contact Number</label>
                    <input type="text" className="form-control" id="storeOwnerContactNumber" value={this.state.store.owner_contact_number} onChange={this.handleStoreOwnerContactNumberChange} placeholder="Point of Interest Owner Contact Number" />
                  </div>
                  <div className="form-group">
                    <label htmlFor="eventbriteID">Eventbrite ID</label>
                    <input type="text" className="form-control" id="eventbriteID" value={this.state.store.eventbrite_id} onChange={this.handleStoreEventbriteIDChange} placeholder="Eventbrite ID" />
                  </div>
                </form>
              </div>
            </div>
          </div>

          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <h3>Point of Interest Location</h3>
                <hr />
              </div>
            </div>
            <div className="row">
              <div className="col-md-8 col-sm-12">
                <form>
                  <div className="form-group">
                    <label htmlFor="storeLocationAddress">Point of Interest Address</label>
                    <input type="text" className="form-control" id="storeLocationAddress" value={this.state.store.store_location.address} onChange={this.handleStoreLocationAddressChange} placeholder="Point of Interest Location Address" />
                  </div>
                  <div className="form-group">
                    <label htmlFor="storeLocationLatitude">Point of Interest Latitude</label>
                    <input type="number" className="form-control" id="storeLocationLatitude" value={this.state.store.store_location.latitude} onChange={this.handleStoreLocationLatitudeChange} placeholder="Point of Interest Location Latitude" />
                  </div>
                  <div className="form-group">
                    <label htmlFor="storeLocationLongitude">Point of Interest Longitude</label>
                    <input type="number" className="form-control" id="storeLocationLongitude" value={this.state.store.store_location.longitude} onChange={this.handleStoreLocationLongitudeChange} placeholder="Point of Interest Location Longitude" />
                  </div>
                </form>
              </div>
            </div>
          </div>
          

          <div className="container-fluid">
            <hr />
            <div className="row" role="toolbar" aria-label="Toolbar with button groups">
              <div className="col-md-4 offset-md-8 text-right">
                <Link to='/pointofinterests'><button className="btn btn-light" style={{marginRight: '10px'}}>Cancel</button></Link>
                {this.state.mode === 'Add' &&
                  <button className="btn btn-primary" onClick={this.addStore} disabled={this.props.isAddingStore || !this.state.canAdd} >Add Point of Interest</button>
                }
                {this.state.mode === 'Edit' &&
                  <button className="btn btn-primary" onClick={this.editStore} disabled={this.props.isEditingStore || !this.state.canEdit} >Edit Point of Interest</button>
                }
              </div>
            </div>
          </div>

        </div>
      </ContentWrapper>
    )
  }
}


const mapStateToProps = state => ({
  stores: state.stores.stores,
  categories: state.categories.categories,
  isLoadingStores: state.stores.isLoadingStores,
  isLoadingCategories: state.categories.isLoadingCategories,
  tags: state.tags.tags,
  isLoadingTags: state.tags.isLoadingTags,
  isAddingStore: state.stores.isAddingStore,
  isEditingStore: state.stores.isEditingStore,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      loadStore,
      loadStores,
      addStore,
      editStore,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(StoreEditor);


// WEBPACK FOOTER //
// ./src/modules/Stores/StoreEditor.js